<div class="flex items-start justify-between border-b border-gray-200 p-4">
  <div class="pr-3 text-lg font-semibold md:text-xl">{{data.name}}</div>
  <button (click)="close()"
          class="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900"
          type="button">
    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path clip-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            fill-rule="evenodd"></path>
    </svg>
  </button>
</div>
<div [innerHTML]="getDescription()" class="max-h-[70vh] overflow-y-auto p-4 text-sm md:text-base">
</div>

